// @ts-ignore no types
import _ from 'lodash'

export const apiToUiDataRowsTranslation = (dataRows: unknown[]) => {
  if (!dataRows) return []
  return dataRows.map(row => {
    let newRow = _.cloneDeep(row) || {}
    newRow = {
      ...newRow,
      channel: _.get(row, 'config[0].channel', null),
      active: _.get(row, 'config[0].is_active', null),
    }
    return newRow
  })
}
